__turbopack_context__.v({
  "card": "SocialBlock-module-scss-module__3AJXxq__card",
  "ig-post": "SocialBlock-module-scss-module__3AJXxq__ig-post",
  "ig-reel": "SocialBlock-module-scss-module__3AJXxq__ig-reel",
  "playButton": "SocialBlock-module-scss-module__3AJXxq__playButton",
  "twitch": "SocialBlock-module-scss-module__3AJXxq__twitch",
  "videoPlayholderRoot": "SocialBlock-module-scss-module__3AJXxq__videoPlayholderRoot",
  "yt-long": "SocialBlock-module-scss-module__3AJXxq__yt-long",
  "yt-short": "SocialBlock-module-scss-module__3AJXxq__yt-short",
});
